"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuill = void 0;
const quill_1 = __importDefault(require("quill"));
const react_1 = require("react");
require("quill/dist/quill.snow.css");
const options = {
    modules: {
        // https://quilljs.com/docs/modules/toolbar/
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
        ],
    },
    // https://quilljs.com/docs/formats/#formats
    formats: [
        /* Inline */
        // 'background',
        'bold',
        // 'code',
        // 'color',
        // 'font',
        'italic',
        'link',
        // 'script',
        // 'size',
        // 'strike',
        // 'underline',
        /* Block */
        // 'blockquote',
        'header',
        // 'indent',
        'list',
        // 'align',
        // 'direction',
        // 'code-block',
        /* Embeds */
        // 'formula',
        // 'image',
        // 'video',
    ],
    theme: 'snow',
};
const useQuill = () => {
    const [quill, setQuill] = (0, react_1.useState)();
    const ref = (0, react_1.useCallback)((element) => {
        setQuill(new quill_1.default(element, options));
    }, []);
    return [ref, quill];
};
exports.useQuill = useQuill;
